/* eslint-disable react/prop-types */
import React from 'react'

import {
    bottomZone,
    topZone,
    plateWidthFt,
} from 'bam-node-baseball-savant/constants/zone.ts'
import StrikeZoneDumb from './Dumb.tsx'
import type { ChartOptions } from '../../../schema/types.ts'

type StrikeZoneGenericProps = {
    xScale: d3.ScaleLinear<number, number>
    yScale: d3.ScaleLinear<number, number>
    chartOptions: ChartOptions
}

export default function StrikeZoneGeneric({
    xScale,
    yScale,
    chartOptions,
}: StrikeZoneGenericProps) {
    const styles = {
        strokeOpacity: chartOptions.strikeZoneBorderOpacity,
        fillOpacity: chartOptions.strikeZoneFillOpacity,
    }
    return (
        <StrikeZoneDumb
            xScale={xScale}
            yScale={yScale}
            szTop={topZone}
            szBot={bottomZone}
            plateWidthFt={plateWidthFt}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...styles}
        />
    )
}
